import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Events from './events/HamburgerEvents';

import styles from './Hamburger.scss';

function Hamburger(props) {
    const {
        isActive = false,
        onClick = () => undefined,
        className = '',
    } = props;

    const clickHamburger = (e) => {
        onClick(e);
        Events.hamburgerClicked();
    };

    return (
        <div
            aria-controls="main-menu"
            aria-expanded={isActive}
            aria-label="Toggle main menu"
            className={classNames(
                styles.hamburger,
                { [styles.open]: isActive },
                className,
            )}
            onClick={clickHamburger}
            role="button"
            tabIndex={-1}
        >
            <span className={styles.topBun} />
            <span className={styles.patty} />
            <span className={styles.bottomBun} />
        </div>
    );
}

Hamburger.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Hamburger;
